import React, { useContext, useState, useEffect } from "react"
import { Button, Modal } from "react-bootstrap"
import "./EditarCohorteModal.css"
import { UsuarioContext } from "../Context/Usuario"
import EditarCohorte from "./EditarCohorte"
import IconoCohorte from "../Utils/IconoCohorte"
import log from "loglevel"

const EditarCohorteModal = (props) => {
  const { usuario } = useContext(UsuarioContext)
  const [showListadoCohortes, setShowListadoCohortes] = useState(false)

  if (!props.cohortes || props.cohortes.length === 0) {
    return ""
  }

  log.debug("Dibujando Editar Cohorte Modal")

  let title =
    props.cohortes.length > 1 ? (
      <span>
        Editando {props.cohortes.length} cohortes <Button onClick={() => {setShowListadoCohortes(true)}}>ver</Button>
        <Modal show={showListadoCohortes} onHide={() => {setShowListadoCohortes(false)}}>
          <Modal.Header closeButton><h4>{props.cohortes.length} cohortes siendo editados</h4></Modal.Header>
          <Modal.Body>        
            <span className="listadoCohortes">
          <ul>
            {props.cohortes.map((cohorteid) => {
              let cohorte = usuario.cohortes[cohorteid]
              return <li key={cohorte.id}>{cohorte.id < 0 ? "Borrador " : ""} {cohorte.nombre} {cohorte.id > 0 ? cohorte.id : ""}</li>
            })}
          </ul>
        </span>
</Modal.Body>
        </Modal>
      </span>
    ) : (
      <span>Editando {usuario.cohortes[props.cohortes[0]].nombre}</span>
    )
  return (
    <div className="EditarCohorteModal">
      <Modal
        show={props.isOpen}
        onHide={() => {
          props.cerrar()
        }}
        className="modalEditarCohorte"
      >
        <Modal.Header className="text-left" closeButton>
          <h3>
            <IconoCohorte background={true} />
            &nbsp;{title}
          </h3>
        </Modal.Header>
        <Modal.Body>
          <EditarCohorte
            cohortes={props.cohortes}
            view={props.view}
            showall={props.showall}
            cerrar={props.cerrar}
            notabs={true}
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  )
}

export default EditarCohorteModal
